import { defineComponent as _defineComponent } from 'vue';
import moment from 'moment';
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LogRow',
    props: {
        log: null
    },
    setup(__props) {
        const props = __props;
        const dateTime = computed(() => {
            return moment(props.log.date).format('HH:mm:ss');
        });
        const level = computed(() => {
            return props.log.level.at(0)?.toUpperCase();
        });
        const color = computed(() => {
            switch (props.log.level) {
                case 'info':
                    return '#2196f3';
                case 'warn':
                    return '#ffeb3b';
                case 'error':
                    return '#d50000';
                default:
                    return '#fff';
            }
        });
        return { __sfc: true, props, dateTime, level, color };
    }
});
